module.exports = __webpack_public_path__ + "files/cv.822780f3.pdf";